import { styled } from "@linaria/react";
export const StyledColumnInfoWrapper = /*#__PURE__*/styled('div')({
  name: "StyledColumnInfoWrapper",
  class: "StyledColumnInfoWrapper_sg4daa5"
});
export const StyledColumnInfo = /*#__PURE__*/styled('div')({
  name: "StyledColumnInfo",
  class: "StyledColumnInfo_s1d8aeoo"
});

require("./StyledCodArticleInfo.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCodArticleInfo.tsx");